/**
 * @desc 新增销售计划
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: Array<defs.TheNewSalesPlanOnSeason>,
): Promise<defs.StandardReturn<boolean>> {
  return defHttp.post({
    url: '/web/sale/year/addPlanSale',
    data,
  });
}

export function mock(
  data: Array<defs.TheNewSalesPlanOnSeason>,
): Promise<defs.StandardReturn<boolean>> {
  return defHttp.post({
    url: '/mock/web/sale/year/addPlanSale',
    data,
  });
}
